import { Component, OnInit } from '@angular/core';
import { AuthService } from 'src/app/core/services/auth.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-service-peb',
  templateUrl: './service-peb.component.html',
  styleUrls: ['./service-peb.component.scss']
})
export class ServicePebComponent implements OnInit {
  constructor(private authService: AuthService, private router: Router) {}

  ngOnInit() {}

  toOrdering() {
    this.router.navigate(['/']);
  }
}
